import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Check } from "lucide-react";

const AboutSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });


  const highlights = [
    "Local expert since 2019",
    "Trusted, discreet, and reliable service",
    "Personalized care tailored to each home and owner"
  ];
  return (
    <section
      id="about"
      ref={sectionRef}
      className="py-24 md:py-32 bg-white"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Photo - Left side, no extra white space */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="flex justify-center"
          >
            <div className="relative">
              {/* Decorative ring */}
              <div className="absolute inset-0 rounded-full border-2 border-gray-200 scale-105" />
              
              {/* Photo - Circular */}
              <div className="relative w-64 h-64 md:w-72 md:h-72 rounded-full overflow-hidden border-4 border-white shadow-xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_1743adff-ba78-456d-9b65-eff00024bbce/artifacts/zyzq7j6y_IMG-20240118-WA0007.jpg"
                  alt="Matthew Ruiz"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Badge */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="absolute -bottom-2 -right-2 bg-white rounded-full px-4 py-2 shadow-lg border border-gray-100"
              >
                <p className="text-lg font-heading font-bold text-navy">5+</p>
                <p className="text-gray-500 text-xs">Years in CB</p>
              </motion.div>
            </div>
          </motion.div>

          {/* Content - Right side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span className="text-accent text-sm font-semibold tracking-wider uppercase">
              About Matthew
            </span>
            
            <h2 className="font-heading text-3xl md:text-4xl text-navy mt-4 mb-6 leading-tight">
              Your Trusted Property <span className="italic">Partner</span>
            </h2>
            
           <p className="text-gray-600 text-base leading-relaxed mb-4">
  Matthew Ruiz has been a full-time resident of Crested Butte since 2019 and brings over 30 years of professional experience built on discretion and reliability.
</p>

<p className="text-gray-600 text-base leading-relaxed mb-4">
  As a Colorado-licensed healthcare professional and local business owner, he is known for accountability and dependable service.
</p>

<p className="text-gray-600 text-base leading-relaxed mb-6">
  His commitment is simple: ensure every property under his care is protected, maintained, and always ready.
</p>

            {/* Highlights - Simple checkmarks like reference */}
            <ul className="space-y-3">
              {highlights.map((item, index) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, x: 20 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <Check className="w-5 h-5 text-accent flex-shrink-0" strokeWidth={2} />
                  <span className="text-gray-700">{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
